module.exports = __webpack_public_path__ + "img/bugreport icon.e7c15018.png";